export default "__VITE_PUBLIC_ASSET__eb439ed7__"